import { get, post, put, patch, del } from "./client";
import { ApiEndpoint } from "./endpoints";

export interface Table {
	id: string;
	key: string;
	areaId: string;
	displayName: string;
	sortIndex: number;
	layoutX: number;
	layoutY: number;
	layoutWidth: number;
	layoutHeight: number;
	peopleSoftLimit: number;
}

export const getTables = async (): Promise<Table[]> => {
	const r = await get(ApiEndpoint.Tables);
	return r[0];
};

export const addTables = async (tables: Table[]) => {
	if (tables.length === 0) return null;

	return await Promise.all(
		tables.map(table => {
			delete table.id;
			return post(ApiEndpoint.Tables, table);
		})
	);
};

export const updateTables = async (tables: Table[]) => {
	if (tables.length === 0) return null;

	return await Promise.all(
		tables.map(table => {
			if (!table.id) {
				throw new Error("Cannot update table without an ID");
			}

			return put(ApiEndpoint.Tables, table.id, table);
		})
	);
};

export const patchTable = async (id: string, updateData: Partial<Table>) => {
	return await patch(ApiEndpoint.Tables, id, updateData);
};

export const removeTables = async (ids: string[]) => {
	if (ids.length === 0) return null;

	return await Promise.all(ids.map(id => del(ApiEndpoint.Tables, id)));
};
